import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import ProcessedWarranty from './processedWarranty';
import WarrantyReport from './warrantyReport';
import WarrantyInvoicing from './warrantyInvoicing';
import WarrantyErrorRate from './warrantyErrorRate';

export const twcConsultyRoutes = [
  {
    'component': <ProcessedWarranty />,
    'path': paths.ProcessedWarranty,
  },
  {
    'component': <WarrantyReport />,
    'path': paths.WarrantyReport,
  },
  {
    'component': <WarrantyInvoicing />,
    'path': paths.WarrantyInvoicing,
  },
  {
    'component': <WarrantyErrorRate />,
    'path': paths.WarrantyErrorRate,
  },
];
